import React, { Component } from 'react';
import Header from '../../components/main.header.component';

class Tintype extends Component {
  render() {
    return (
      <div className="Tintype">
        <Header
          props={this.props}
        />
        <div className="tintype-responsive">
          <div className="tintype-image">
            <img src="/images/tintypes/acacia.jpg" alt=""/>
          </div>
          <div className="tintype-image">
            <img src="/images/tintypes/hand.jpg" alt=""/>
          </div>
        </div>
        <div className="tintype-middle">
          <div className="tintype-image">
            <img src="/images/tintypes/flower.jpg" alt=""/>
          </div>
        </div>
        <div className="tintype-right">
          <div className="tintype-image">
            <img src="/images/tintypes/arm.jpg" alt=""/>
          </div>
          <div className="tintype-image">
            <img src="/images/tintypes/self.jpg" alt=""/>
          </div>
        </div>
      </div>
    );
  }
}

export default (Tintype);

